import React, { useState } from 'react';
import { DashboardControls } from '@/components/Overview/DashboardControls';
import { GlobalMetrics } from '@/components/Overview/GlobalMetrics';
import { PackageStats } from '@/components/Overview/PackageStats';
import { RewardAnalysisTable } from '@/components/Overview/RewardAnalysisTable';
import { DashboardCharts } from '@/components/Overview/DashboardCharts';
import { Constants, MockDataMap } from '@/components/Overview/type';

const CONSTANTS: Constants = {
  FUND_PERCENTAGE: 0.08,
  TITAN_WEIGHT: 6,
  PIONEER_WEIGHT: 1,
  MIN_ROI_PERCENT: 0.03,
  TITAN_PRICE: 10000,
  PIONEER_PRICE: 2000
};

const MOCK_DATA: MockDataMap = {
  "1": { netRevenue: 5000000, numTitan: 150, numPioneer: 300 },
  "2": { netRevenue: 12000000, numTitan: 180, numPioneer: 350 },
  "3": { netRevenue: 25000000, numTitan: 200, numPioneer: 400 }
};

export const DashboardMain: React.FC = () => {
  const [selectedMonth, setSelectedMonth] = useState<string>("3");
  const data = MOCK_DATA[selectedMonth];

  // Các bước tính toán nghiệp vụ
  const totalFund = data.netRevenue * CONSTANTS.FUND_PERCENTAGE;
  const totalShares = (data.numTitan * CONSTANTS.TITAN_WEIGHT) + (data.numPioneer * CONSTANTS.PIONEER_WEIGHT);
  const valuePerShare = totalShares > 0 ? (totalFund / totalShares) : 0;

  // Tính toán gói Titan
  const actualTitan = valuePerShare * CONSTANTS.TITAN_WEIGHT;
  const minTitan = CONSTANTS.MIN_ROI_PERCENT * CONSTANTS.TITAN_PRICE;
  const finalTitan = Math.max(actualTitan, minTitan);

  // Tính toán gói Pioneer
  const actualPioneer = valuePerShare * CONSTANTS.PIONEER_WEIGHT;
  const minPioneer = CONSTANTS.MIN_ROI_PERCENT * CONSTANTS.PIONEER_PRICE;
  const finalPioneer = Math.max(actualPioneer, minPioneer);

  return (
    <main className="flex-1 overflow-x-hidden overflow-y-auto bg-gray-100 p-6 text-gray-800">
      
      {/* 1. Bộ điều khiển tháng */}
      <DashboardControls 
        selectedMonth={selectedMonth} 
        onMonthChange={setSelectedMonth} 
      />

      {/* 2. Chỉ số tổng quan */}
      <GlobalMetrics 
        netRevenue={data.netRevenue}
        totalFund={totalFund}
        valuePerShare={valuePerShare}
        totalShares={totalShares}
        finalTitan={finalTitan}
        titanPrice={CONSTANTS.TITAN_PRICE}
      />

      {/* 3. Khu vực phân tích dữ liệu & Bảng */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-8">
        <div className="lg:col-span-1">
          <PackageStats 
            numTitan={data.numTitan}
            numPioneer={data.numPioneer}
            titanPrice={CONSTANTS.TITAN_PRICE}
            pioneerPrice={CONSTANTS.PIONEER_PRICE}
          />
        </div>
        <div className="lg:col-span-2">
          <RewardAnalysisTable 
            valuePerShare={valuePerShare}
            actualTitan={actualTitan}
            minTitan={minTitan}
            finalTitan={finalTitan}
            actualPioneer={actualPioneer}
            minPioneer={minPioneer}
            finalPioneer={finalPioneer}
            titanPrice={CONSTANTS.TITAN_PRICE}
            pioneerPrice={CONSTANTS.PIONEER_PRICE}
          />
        </div>
      </div>

      {/* 4. Khối đồ thị trực quan */}
      <DashboardCharts 
        minTitanGuarantee={minTitan}
        currentRevenue={data.netRevenue}
        currentFund={totalFund}
      />

    </main>
  );
};